module.exports = __webpack_public_path__ + "static/media/logo.6b4894a2.png";